import { PromoCodesForm } from 'components/promoCodes/PromoCodesForm/PromoCodesForm'
import { useParams } from 'react-router-dom'

export const PromoCodesEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  return <PromoCodesForm mode='edit' promoCodeId={id as string} />
}
